// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EditableTable.css */

/* General styles for non-table components */
.editable-table {
  max-height: 100%;
  overflow-y: auto;
}

.messageSection {
  display: flex;
  border-bottom: 1px solid lightgrey;
  z-index: 10;
}

.messageSectionMessage {
  padding: 10;
}

/* Buttons div styles */
.buttons-div {
  background-color: #eeeeeeaa;
  position: absolute;
  display: flex;
  align-items: flex-end;
  top: 2vh;
  left: -10vw;
}

.buttons-div-edit {
  background-color: #eeeeeeaa;
  position: absolute;
  display: flex;
  align-items: flex-end;
  top: 2vh;
  left: -5vw;
}

/* Expandable cell styles */
.expandable-cell:hover {
  background-color: #99ddff99; /* Change the background color on hover */
  cursor: pointer; /* Change the cursor to indicate it's clickable */
}

.expandable-cell {
  background-color: #99ddff33; /* Change the background color on hover */
  position: relative;
  border-radius: 5px;
}

.expandable-preview {
  display: flex;
  cursor: pointer;
}

.expanded-content-heading {
  font-weight: bold;
  font-size: 15px;
  border-bottom: 1px solid #7a7a7a;
  margin-bottom: 2px;
  background-color: #99ddff99;
  padding: 5px;
  border-radius: 5px;
  width: max-content;
}

.expandable-preview-data {
  padding: 5px;
}

/* Optional: Add transitions for smoother animation */
.expandable-cell,
.expandable-content {
  transition: height 0.3s ease-out, opacity 0.3s ease-out;
}

.expanded-content-cell {
  position: absolute;
  z-index: 1000; /* Ensure it's above other elements */
  top: inherit;
  left: inherit;
  width: max-content;
  height: auto;
  background-color: rgb(236, 236, 236); /* Set the background color */
  border: 1px solid rgb(143, 143, 143);
  border-radius: 5px;
}

.expandable-content {
  padding: 10px;
}

.expanded-content-cell-list {
  align-items: center;
  justify-content: center;
  width: max-content;
  max-height: 20vh;
  overflow-y: auto;
}

.expanded-content-cell-list-item {
  margin-bottom: 1px;
  background-color: #11ff1122;
  border-bottom: 1px solid #7a7a7a55;
  padding: 2px;
  border-radius: 5px;
}

/* Ant Design Switch disabled style */
.ant-switch-disabled {
  background-color: #0775bc;
}
`, "",{"version":3,"sources":["webpack://./src/components/edit-table/edit-table.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B,EAAE,yCAAyC;EACtE,eAAe,EAAE,iDAAiD;AACpE;;AAEA;EACE,2BAA2B,EAAE,yCAAyC;EACtE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,qDAAqD;AACrD;;EAEE,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,qCAAqC;EACpD,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,oCAAoC,EAAE,6BAA6B;EACnE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B","sourcesContent":["/* EditableTable.css */\n\n/* General styles for non-table components */\n.editable-table {\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n.messageSection {\n  display: flex;\n  border-bottom: 1px solid lightgrey;\n  z-index: 10;\n}\n\n.messageSectionMessage {\n  padding: 10;\n}\n\n/* Buttons div styles */\n.buttons-div {\n  background-color: #eeeeeeaa;\n  position: absolute;\n  display: flex;\n  align-items: flex-end;\n  top: 2vh;\n  left: -10vw;\n}\n\n.buttons-div-edit {\n  background-color: #eeeeeeaa;\n  position: absolute;\n  display: flex;\n  align-items: flex-end;\n  top: 2vh;\n  left: -5vw;\n}\n\n/* Expandable cell styles */\n.expandable-cell:hover {\n  background-color: #99ddff99; /* Change the background color on hover */\n  cursor: pointer; /* Change the cursor to indicate it's clickable */\n}\n\n.expandable-cell {\n  background-color: #99ddff33; /* Change the background color on hover */\n  position: relative;\n  border-radius: 5px;\n}\n\n.expandable-preview {\n  display: flex;\n  cursor: pointer;\n}\n\n.expanded-content-heading {\n  font-weight: bold;\n  font-size: 15px;\n  border-bottom: 1px solid #7a7a7a;\n  margin-bottom: 2px;\n  background-color: #99ddff99;\n  padding: 5px;\n  border-radius: 5px;\n  width: max-content;\n}\n\n.expandable-preview-data {\n  padding: 5px;\n}\n\n/* Optional: Add transitions for smoother animation */\n.expandable-cell,\n.expandable-content {\n  transition: height 0.3s ease-out, opacity 0.3s ease-out;\n}\n\n.expanded-content-cell {\n  position: absolute;\n  z-index: 1000; /* Ensure it's above other elements */\n  top: inherit;\n  left: inherit;\n  width: max-content;\n  height: auto;\n  background-color: rgb(236, 236, 236); /* Set the background color */\n  border: 1px solid rgb(143, 143, 143);\n  border-radius: 5px;\n}\n\n.expandable-content {\n  padding: 10px;\n}\n\n.expanded-content-cell-list {\n  align-items: center;\n  justify-content: center;\n  width: max-content;\n  max-height: 20vh;\n  overflow-y: auto;\n}\n\n.expanded-content-cell-list-item {\n  margin-bottom: 1px;\n  background-color: #11ff1122;\n  border-bottom: 1px solid #7a7a7a55;\n  padding: 2px;\n  border-radius: 5px;\n}\n\n/* Ant Design Switch disabled style */\n.ant-switch-disabled {\n  background-color: #0775bc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
